import React, { useEffect, useState, createContext } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import NewPurchasePage from "../pages/NewPurchasePage/NewPurchasePage";
import NewBillPage from "../pages/NewBillPage/NewBillPage";
import BillsPage from "../pages/BillsPage/BillsPage";
import PurchasesPage from "../pages/PurchasesPage/PurchasesPage";
import LoginPage from "../pages/LoginPage/LoginPage";
import SignUpPage from "../pages/SignUpPage/SignUpPage";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute";
import "./App.css";
import SuppliersPage from "../pages/SuppliersPage/SuppliersPage";
import MetalsPage from "../pages/MetalsPage/MetalsPage";
import "antd/dist/reset.css";
import MaterialsPage from "../pages/MaterialsPage/MaterialsPage";
import Cookies from "universal-cookie";
import InventoryPage from "../pages/InventoryPage/InventoryPage";
import NewShipmentPage from "../pages/NewShipmentPage/NewShipmentPage";
import ShipmentsPage from "../pages/Shipments/ShipmentsPage";
import BundlesPage from "../pages/BundlesPage/BundlesPage";
import NewBundlePage from "../pages/NewBundlePage/NewBundlePage";
import AveragePricesPage from "../pages/AveragePricesPage/AveragePricesPage";
import SummaryPage from "../pages/SummaryPage/SummaryPage";
import HomePage from "../pages/HomePage/HomePage";
import SalesPage from "../pages/Sales/SalesPage";
import NewSalePage from "../pages/NewSalePage/NewSalePage";
import BuyersPage from "../pages/BuyersPage/BuyersPage";
import SalesMaterialsPage from "../pages/SalesMaterialsPage/SalesMaterialsPage";
import OverviewPage from "../pages/OverviewPage/OverviewPage";
import OverviewMaterialsPage from "../pages/OverviewMaterialsPage/OverviewMaterialsPage";
import InvoicesPage from "../pages/InvoicesPage/InvoicesPage";
import NewInvoicePage from "../pages/NewInvoicePage/NewInvoicePage";
import ShipmentsMaterialsPage from "../pages/ShipmentsMaterialsPage/ShipmentsMaterialsPage";

const App = () => {
  const [scaleSerialPort, setScaleSerialPort] = useState(null) as any;
  const [scaleReader, setScalecaleReader] = useState(null) as any;
  const [userRole, setUserRole] = useState(null) as any;
  const [userID, setUserID] = useState(null) as any;
  const cookies = new Cookies();
  // const userRole = cookies.get("USER_ROLE");
  useEffect(() => {
    setUserRole(cookies.get("USER_ROLE"));
    setUserID(cookies.get("USER_ID"));
    // const cookieChangeListener: any = (currOfficeCookie: any) => {
    //   console.log("Cookie ", currOfficeCookie, currOfficeCookie.name === "CURR_OFFICE");
    //   if (currOfficeCookie.name === "CURR_OFFICE") setOfficeValue(currOfficeCookie.value);
    // };
    // cookies.addChangeListener(cookieChangeListener);
    // return () => {
    //   cookies.removeChangeListener(cookieChangeListener);
    // };
  });

  const updateScaleSerialPort = (port: any) => {
    setScaleSerialPort(port);
  };

  const updateScaleReader = (reader: any) => {
    setScalecaleReader(reader);
  };

  const getUserRoleCookie = () => {
    setUserRole(cookies.get("USER_ROLE"));
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage getUserRoleCookie={getUserRoleCookie} />} />
        {/* <Route path="/signup" element={<SignUpPage />} /> */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/newpurchase"
            element={
              <NewPurchasePage
                scaleSerialPort={scaleSerialPort}
                scaleReader={scaleReader}
                updateScaleSerialPort={updateScaleSerialPort}
                updateScaleReader={updateScaleReader}
              />
            }
          />
          <Route
            path="/newsale"
            element={
              <NewSalePage
                scaleSerialPort={scaleSerialPort}
                scaleReader={scaleReader}
                updateScaleSerialPort={updateScaleSerialPort}
                updateScaleReader={updateScaleReader}
              />
            }
          />
          <Route
            path="/purchase/:purchaseID"
            element={
              <NewPurchasePage
                scaleSerialPort={scaleSerialPort}
                scaleReader={scaleReader}
                updateScaleSerialPort={updateScaleSerialPort}
                updateScaleReader={updateScaleReader}
              />
            }
          />
          <Route
            path="/sale/:saleID"
            element={
              <NewSalePage
                scaleSerialPort={scaleSerialPort}
                scaleReader={scaleReader}
                updateScaleSerialPort={updateScaleSerialPort}
                updateScaleReader={updateScaleReader}
              />
            }
          />
          <Route path="/purchases" element={<PurchasesPage />} />
          <Route path="/materials" element={<MaterialsPage />} />
          <Route path="/salesmaterials" element={<SalesMaterialsPage />} />
          <Route path="/suppliers" element={<SuppliersPage />} />
          <Route path="/buyers" element={<BuyersPage />} />
          <Route path="/metals" element={<MetalsPage />} />
          <Route path="/bundles" element={<BundlesPage />} />
          <Route
            path="/newbundle"
            element={
              <NewBundlePage
                scaleSerialPort={scaleSerialPort}
                scaleReader={scaleReader}
                updateScaleSerialPort={updateScaleSerialPort}
                updateScaleReader={updateScaleReader}
              />
            }
          />
          <Route path="/shipments" element={<ShipmentsPage />} />
          <Route path="/shipmentsmaterials" element={<ShipmentsMaterialsPage />} />
          <Route
            path="/newshipment"
            element={
              <NewShipmentPage
                scaleSerialPort={scaleSerialPort}
                scaleReader={scaleReader}
                updateScaleSerialPort={updateScaleSerialPort}
                updateScaleReader={updateScaleReader}
              />
            }
          />
          <Route
            path="/shipment/:shipmentID"
            element={
              <NewShipmentPage
                scaleSerialPort={scaleSerialPort}
                scaleReader={scaleReader}
                updateScaleSerialPort={updateScaleSerialPort}
                updateScaleReader={updateScaleReader}
              />
            }
          />
          <Route path="/bill/:billID" element={<NewBillPage />} />
          <Route path="/bills" element={<BillsPage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/averageprices" element={<AveragePricesPage />} />
          <Route path="/sales" element={<SalesPage />} />
          <Route path="/invoice/:invoiceID" element={<NewInvoicePage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          {(userID === "333a7991-072c-4781-b54b-9bd83787007c" || userID === "ce2cee02-8c4d-4ade-8992-f108acb4897d") && (
            <>
              <Route path="/overview" element={<OverviewPage />} />
              <Route path="/overviewmaterials" element={<OverviewMaterialsPage />} />
            </>
          )}
          {/* <Route path="/sales/materials" element={<AveragePricesPage />} /> */}
          {/* {userRole === "admin" && (
            <>
              <Route path="/summary" element={<SummaryPage />} />
            </>
          )} */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
